/*************************************************************
 * ErrorBoundary.js - Error handling component
 *************************************************************/

export const ErrorBoundary = ({ error, onRetry, children }) => {
    if (error) {
        return (
            <div className="alert alert-danger text-center m-4">
                <i className="fas fa-exclamation-triangle fa-3x mb-3 text-danger"></i>
                <h4>Something went wrong</h4>
                <p className="mb-3">{error.message || 'An unexpected error occurred'}</p>
                {error.endpoint && (
                    <small className="text-muted d-block mb-3">
                        Endpoint: {error.endpoint}
                    </small>
                )}
                {onRetry && (
                    <button className="btn btn-outline-danger" onClick={onRetry}>
                        <i className="fas fa-redo mr-2"></i>
                        Try Again
                    </button>
                )}
            </div>
        );
    }

    return children;
};